import { ValidationObserver } from "vee-validate/dist/vee-validate.full";
import BInput from "@/components/singles/BInput/component.vue";
import BSelect from "@/components/singles/BSelect/component.vue";
import BArea from "@/components/singles/BArea/component.vue";

export default {
  name: "user-management",
  components: {
    ValidationObserver,
    BInput,
    BArea,
    BSelect,
    validating: false
  },
  props: ["elements", "mode"],
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    async Validate() {
      if (!this.validating) {
        this.validating = true;
        setTimeout(async () => {
          let observer = this.$refs.observer;
          if (observer) {
            let valid = await observer.validate({
              silent: true
            });
            this.$emit("valid", valid);
          }

          this.validating = false;
        }, 100);
      }
    },

    async Submit() {
      let observer = this.$refs.observer;
      let valid = false;

      if (observer) valid = await observer.validate();

      if (valid) {
        let inputValues = {};
        let areaValues = {};
        let selected = {};

        if (this.elements.inputs) {
          for (const x of this.elements.inputs) {
            inputValues[x.name] = x.value;
          }
        }

        if (this.elements.areas) {
          for (const x of this.elements.areas) {
            areaValues[x.name] = x.value;
          }
        }

        if (this.elements.selects) {
          for (const x of this.elements.selects) {
            selected[x.itemsProp] = x.selected;
          }
        }

        const toReturn = {
          inputs: inputValues,
          areas: areaValues,
          selects: selected
        };

        this.$emit("submit", toReturn);
      }
    }
  }
};
